import { controls, grouped } from "../controls";
const bank_pacs_parameters = {
  label: "Bank Parameters",
  pageLabel: "Bank Parameters", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  formTabs:
  {
    allTabs: [
      { label: "General", uid: "general" },
      { label: "Servers", uid: "servers" },
      { label: "Bank Districts", uid: "bank_districts" },
      { label: "Bank Farmer Settings", uid: "bank_farmer_settings" },
      { label: "Scale Of Finances", uid: "scale_of_finances" },
      { label: "Bank Loan Policies", uid: "bank_loan_policies" },
      { label: "Farmer Shares", uid: "farmer_shares" },
      { label: "Bank Cbs Settings", uid: "bank_cbs_settings" },
      { label: "Ncl Parameters", uid: "ncl_parameters" },
      { label: "Refinances", uid: "refinances" },
      { label: "Pacs Notification", uid: "pacs_notification" },
      { label: "Recovery Sequences", uid: "recovery_sequences" },
      { label: "Rate Of Interests", uid: "rate_of_interests" },
      { label: "Interest Subvisions", uid: "interest_subvisions" },
      { label: "Recoveries", uid: "recoveries" },
      { label: "Bank Disbursements", uid: "bank_disbursements" },
      { label: "Login Security Types", uid: "login_security_types" },
      { label: "Renewals", uid: "renewals" },
      { label: "Bank Pacs Settings", uid: "bank_pacs_settings" }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Season" }),
    ...controls.oc({ tab: "filter", c: "Season", placeHolder: "Season Code", name: "BankPACSParameter-season-season_code", fastpath: "seasons" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "BankPACSParameter-season-season_display" }),
    ...controls.displayText({ tab: "filter", label: "Hangam" }),
    ...controls.oc({ tab: "filter", c: "Hangam", placeHolder: "Hangam Code", name: "BankPACSParameter-hangam-hangam_code", fastpath: "hangams" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "BankPACSParameter-hangam-hangam_display" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Bank Pacs Parameter Code", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "bank_pacs_parameter_code", isRequired: false, maxlength: 30 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Description", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "bank_pacs_parameter_display", isRequired: false, width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "general", label: "Season", star: false }),
    ...controls.oc({ tab: "general", c: "Season", placeHolder: "Season Code", name: "season_code", isRequired: false, fastpath: "seasons" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "season_display" }),
    ...controls.displayText({ tab: "general", label: "Hangam", star: false }),
    ...controls.oc({ tab: "general", c: "Hangam", placeHolder: "Hangam Code", name: "hangam_code", isRequired: false, fastpath: "hangams" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "hangam_display" }),
    ...controls.displayText({ tab: "general", label: "Auto Ncl Duration", star: false }),
    ...controls.numberOnly({ tab: "general", placeHolder: "in Years", name: "auto_ncl_duration", isRequired: false, maxlength: 200, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "general", label: "Bank Maximum Limit", star: false }),
    ...controls.numberOnly({ tab: "general", placeHolder: "in rupees", name: "max_imcl_limit", isRequired: false, maxlength: 200, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Max Share Amount", star: false }),
    ...controls.numberOnly({ tab: "general", placeHolder: "in rupees", name: "max_share_limit", isRequired: false, maxlength: 200, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "servers", label: "Max File Size In Kb", star: false }),
    ...controls.numberOnly({ tab: "servers", placeHolder: "", name: "servers.max_file_size_in_kb", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "servers", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "servers", label: "File Extension", star: false }),
    ...controls.oc({ tab: "servers", c: "FileExtension", placeHolder: "File Extension Code", name: "servers.file_extension_code", isRequired: false, fastpath: "file_extensions" }),
    ...controls.showData({ tab: "servers", displaytype: "capital", data: "servers.file_extension_display" }),
    ...controls.displayText({ tab: "servers", label: "Ip", star: false }),
    ...controls.text({ tab: "servers", placeHolder: "", name: "servers.ip", isRequired: false, width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "servers", label: "Port", star: false }),
    ...controls.numberOnly({ tab: "servers", placeHolder: "", name: "servers.port", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "servers", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "servers", label: "Db Name", star: false }),
    ...controls.text({ tab: "servers", placeHolder: "", name: "servers.db_name", isRequired: false, width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "servers", label: "User Name", star: false }),
    ...controls.text({ tab: "servers", placeHolder: "", name: "servers.user_name", isRequired: false, width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "servers", label: "Password", star: false }),
    ...controls.text({ tab: "servers", placeHolder: "", name: "servers.password", isRequired: false, width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "servers", label: "Dialect", star: false }),
    ...controls.text({ tab: "servers", placeHolder: "", name: "servers.dialect", isRequired: false, width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "bank_districts", label: "District", star: false }),
    ...controls.oc({ tab: "bank_districts", c: "District", placeHolder: "District Code", name: "district_code", isRequired: false, fastpath: "districts" }),
    ...controls.showData({ tab: "bank_districts", displaytype: "capital", data: "district_display" }),

    ...controls.displayText({ tab: "bank_districts", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "bank_districts", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "bank_districts",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "bank_districts",
        requiredField: ["district_code", "district_display", "district_uid",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "bank_districts",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "bank_districts",
        requiredField: ["district_code", "district_display", "district_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "bank_districts",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "District Code", field: "district_code" },
        { label: "District Display", field: "district_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "bank_districts"
    },

    ...controls.displayText({ tab: "bank_farmer_settings", label: "Farmer Type", star: false }),
    ...controls.oc({ tab: "bank_farmer_settings", c: "FarmerType", placeHolder: "Farmer Type Code", name: "farmer_type_code", isRequired: false, fastpath: "farmer_types" }),
    ...controls.showData({ tab: "bank_farmer_settings", displaytype: "capital", data: "farmer_type_display" }),


    ...controls.displayText({ tab: "bank_farmer_settings", label: "Max Limit" }),
    ...controls.floatOnly({ tab: "bank_farmer_settings", placeHolder: "", name: "max_limit", maxlength: 18 }),
    ...controls.displayText({ tab: "bank_farmer_settings", label: "", width: "col-sm-2" }),

    ...controls.checkBox({ tab: "bank_farmer_settings", label: "Active", default: false, name: "bank_farmer_setting_active", isReadOnly: "edit" }),

    ...controls.displayText({ tab: "bank_farmer_settings", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "bank_farmer_settings", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "bank_farmer_settings",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "bank_farmer_settings",
        requiredField: ["max_limit", "farmer_type_code", "farmer_type_display", "farmer_type_uid", "bank_farmer_setting_active",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "bank_farmer_settings",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "bank_farmer_settings",
        requiredField: ["max_limit", "farmer_type_code", "farmer_type_display", "farmer_type_uid", "bank_farmer_setting_active",]
      }, width: "col-sm-2"
    }),
    {
      tab: "bank_farmer_settings",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Max Limit", field: "max_limit" },
        { label: "Farmer Type Code", field: "farmer_type_code" },
        { label: "Farmer Type Display", field: "farmer_type_display" },
        { label: "Bank Farmer Setting Active", field: "bank_farmer_setting_active", displaytype: "tick" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "bank_farmer_settings"
    },
    ...controls.displayText({ tab: "scale_of_finances", label: "Crop", star: false }),
    ...controls.oc({ tab: "scale_of_finances", c: "Crop", placeHolder: "Crop Code", name: "crop_code", isRequired: false, fastpath: "crops" }),
    ...controls.showData({ tab: "scale_of_finances", displaytype: "capital", data: "crop_display" }),
    ...controls.displayText({ tab: "scale_of_finances", label: "Land Type", star: false }),
    ...controls.oc({ tab: "scale_of_finances", c: "LandType", placeHolder: "Land Type Code", name: "land_type_code", isRequired: false, fastpath: "land_types", isReadOnly: "edit" }),
    ...controls.showData({ tab: "scale_of_finances", displaytype: "capital", data: "land_type_display" }),
    ...controls.displayText({ tab: "scale_of_finances", label: "Amount" }),
    ...controls.floatOnly({ tab: "scale_of_finances", placeHolder: "", name: "amount_per", maxlength: 18 }),
    ...controls.displayText({ tab: "scale_of_finances", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "scale_of_finances", label: "Unit", star: false }),
    ...controls.oc({ tab: "scale_of_finances", c: "Unit", placeHolder: "Unit Code", name: "unit_code", isRequired: false, fastpath: "units", defaultValue: 'a' }),
    ...controls.showData({ tab: "scale_of_finances", displaytype: "capital", data: "unit_display" }),
    ...controls.displayText({ tab: "scale_of_finances", label: "Safety Buffer Percentage" }),
    ...controls.floatOnly({ tab: "scale_of_finances", placeHolder: "", name: "safety_buffer_percentage", maxlength: 4 }),
    ...controls.displayText({ tab: "scale_of_finances", label: "", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "scale_of_finances", label: "Include Insurance Amount", default: false, name: "include_insurance_amount" }),

    ...controls.displayText({ tab: "scale_of_finances", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "scale_of_finances", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "scale_of_finances",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "scale_of_finances",
        requiredField: ["crop_code", "crop_display", "crop_uid", "land_type_code", "land_type_display", "land_type_uid", "amount_per", "unit_code", "unit_display", "unit_uid", "safety_buffer_percentage", "include_insurance_amount",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "scale_of_finances",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "scale_of_finances",
        requiredField: ["crop_code", "crop_display", "crop_uid", "land_type_code", "land_type_display", "land_type_uid", "amount_per", "unit_code", "unit_display", "unit_uid", "safety_buffer_percentage", "include_insurance_amount",]
      }, width: "col-sm-2"
    }),
    {
      tab: "scale_of_finances",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Crop Code", field: "crop_code" },
        { label: "Crop Display", field: "crop_display" },
        { label: "Land Type Code", field: "land_type_code" },
        { label: "Land Type Display", field: "land_type_display" },
        { label: "Amount Per", field: "amount_per" },
        { label: "Unit Code", field: "unit_code" },
        { label: "Unit Display", field: "unit_display" },
        { label: "Safety Buffer Percentage", field: "safety_buffer_percentage" },
        { label: "Include Insurance Amount", field: "include_insurance_amount", displaytype: "tick" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "scale_of_finances"
    },

    ...controls.displayText({ tab: "bank_loan_policies", label: "Loan Renew Type", star: false }),
    ...controls.oc({ tab: "bank_loan_policies", c: "LoanRenewType", placeHolder: "Loan Renew Type", name: "loan_renew_type_code", isRequired: false, fastpath: "loan_renew_types", isReadOnly: "edit" }),
    ...controls.showData({ tab: "bank_loan_policies", displaytype: "capital", data: "loan_renew_type_display" }),

    // ...controls.displayText({ tab: "bank_loan_policies", label: "Mcl Buffer" }),
    // ...controls.floatOnly({ tab: "bank_loan_policies", placeHolder: "", name: "mcl_buffer", maxlength: 4 }),
    // ...controls.displayText({ tab: "bank_loan_policies", label: "", width: "col-sm-2" }),



    ...controls.displayText({ tab: "bank_loan_policies", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "bank_loan_policies", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "bank_loan_policies",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "bank_loan_policies",
        requiredField: ["mcl_buffer", "loan_renew_type_code", "loan_renew_type_display", "loan_renew_type_uid",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "bank_loan_policies",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "bank_loan_policies",
        requiredField: ["mcl_buffer", "loan_renew_type_code", "loan_renew_type_display", "loan_renew_type_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "bank_loan_policies",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Mcl Buffer", field: "mcl_buffer" },
        { label: "Loan Renew Type Code", field: "loan_renew_type_code" },
        { label: "Loan Renew Type Display", field: "loan_renew_type_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "bank_loan_policies"
    },
    ...controls.displayText({ tab: "farmer_shares", label: "% for New Loan" }),
    ...controls.floatOnly({ tab: "farmer_shares", placeHolder: "", name: "new_buffer", maxlength: 4 }),
    ...controls.displayText({ tab: "farmer_shares", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "farmer_shares", label: "% for Old Loan" }),
    ...controls.floatOnly({ tab: "farmer_shares", placeHolder: "", name: "old_buffer", maxlength: 4 }),
    ...controls.displayText({ tab: "farmer_shares", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "farmer_shares", label: "Farmer Type", star: false }),
    ...controls.oc({ tab: "farmer_shares", c: "FarmerType", placeHolder: "Farmer Type Code", name: "farmer_type_code", isRequired: false, fastpath: "farmer_types" }),
    ...controls.showData({ tab: "farmer_shares", displaytype: "capital", data: "farmer_type_display" }),

    ...controls.displayText({ tab: "farmer_shares", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "farmer_shares", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "farmer_shares",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "farmer_shares",
        requiredField: ["new_buffer", "old_buffer", "farmer_type_code", "farmer_type_display", "farmer_type_uid",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "farmer_shares",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "farmer_shares",
        requiredField: ["new_buffer", "old_buffer", "farmer_type_code", "farmer_type_display", "farmer_type_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "farmer_shares",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "New Buffer", field: "new_buffer" },
        { label: "Old Buffer", field: "old_buffer" },
        { label: "Farmer Type Code", field: "farmer_type_code" },
        { label: "Farmer Type Display", field: "farmer_type_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "farmer_shares"
    },
    ...controls.checkBox({ tab: "bank_cbs_settings", label: "Allow Direct Loans", default: false, name: "allow_direct_loans" }),
    ...controls.checkBox({ tab: "bank_cbs_settings", label: "Same Day Begin In The Branch", default: false, name: "same_day_begin_in_the_branch" }),

    ...controls.displayText({ tab: "bank_cbs_settings", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "bank_cbs_settings", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "bank_cbs_settings",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "bank_cbs_settings",
        requiredField: ["allow_direct_loans", "same_day_begin_in_the_branch",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "bank_cbs_settings",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "bank_cbs_settings",
        requiredField: ["allow_direct_loans", "same_day_begin_in_the_branch",]
      }, width: "col-sm-2"
    }),
    {
      tab: "bank_cbs_settings",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Allow Direct Loans", field: "allow_direct_loans", displaytype: "tick" },
        { label: "Same Day Begin In The Branch", field: "same_day_begin_in_the_branch", displaytype: "tick" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "bank_cbs_settings"
    },
    ...controls.displayText({ tab: "ncl_parameters", label: "Ncl Increment Purpose", star: false }),
    ...controls.oc({ tab: "ncl_parameters", c: "NclIncrementPurpose", placeHolder: "Ncl Increment Purpose", name: "ncl_increment_purpose_code", isRequired: false, fastpath: "ncl_increment_purposes" }),
    ...controls.showData({ tab: "ncl_parameters", displaytype: "capital", data: "ncl_increment_purpose_display" }),
    ...controls.displayText({ tab: "ncl_parameters", label: "Ncl Increment Percentage" }),
    ...controls.floatOnly({ tab: "ncl_parameters", placeHolder: "", name: "ncl_increment_percentage", maxlength: 4 }),
    ...controls.displayText({ tab: "ncl_parameters", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "ncl_parameters", label: "Land Type", star: false }),
    ...controls.oc({ tab: "ncl_parameters", c: "LandType", placeHolder: "Land Type Code", name: "land_type_code", isRequired: false, fastpath: "land_types" }),
    ...controls.showData({ tab: "ncl_parameters", displaytype: "capital", data: "land_type_display" }),
    ...controls.displayText({ tab: "ncl_parameters", label: "Farmer Type", star: false }),
    ...controls.oc({ tab: "ncl_parameters", c: "FarmerType", placeHolder: "Farmer Type Code", name: "farmer_type_code", isRequired: false, fastpath: "farmer_types" }),
    ...controls.showData({ tab: "ncl_parameters", displaytype: "capital", data: "farmer_type_display" }),

    ...controls.displayText({ tab: "ncl_parameters", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "ncl_parameters", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "ncl_parameters",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "ncl_parameters",
        requiredField: ["ncl_increment_purpose_code", "ncl_increment_purpose_display", "ncl_increment_purpose_uid", "ncl_increment_percentage", "land_type_code", "land_type_display", "land_type_uid", "farmer_type_code", "farmer_type_display", "farmer_type_uid",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "ncl_parameters",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "ncl_parameters",
        requiredField: ["ncl_increment_purpose_code", "ncl_increment_purpose_display", "ncl_increment_purpose_uid", "ncl_increment_percentage", "land_type_code", "land_type_display", "land_type_uid", "farmer_type_code", "farmer_type_display", "farmer_type_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "ncl_parameters",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Ncl Increment Purpose Code", field: "ncl_increment_purpose_code" },
        { label: "Ncl Increment Purpose Display", field: "ncl_increment_purpose_display" },
        { label: "Ncl Increment Percentage", field: "ncl_increment_percentage" },
        { label: "Land Type Code", field: "land_type_code" },
        { label: "Land Type Display", field: "land_type_display" },
        { label: "Farmer Type Code", field: "farmer_type_code" },
        { label: "Farmer Type Display", field: "farmer_type_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "ncl_parameters"
    },
    ...controls.displayText({ tab: "refinances", label: "Min Regular Recovery" }),
    ...controls.floatOnly({ tab: "refinances", placeHolder: "", name: "min_regular_recovery", maxlength: 18 }),
    ...controls.displayText({ tab: "refinances", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "refinances", label: "Max Npa" }),
    ...controls.floatOnly({ tab: "refinances", placeHolder: "", name: "max_npa", maxlength: 18 }),
    ...controls.displayText({ tab: "refinances", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "refinances", label: "Min Ots" }),
    ...controls.floatOnly({ tab: "refinances", placeHolder: "", name: "min_ots", maxlength: 18 }),
    ...controls.displayText({ tab: "refinances", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "refinances", label: "Lower Interest Rate" }),
    ...controls.floatOnly({ tab: "refinances", placeHolder: "", name: "lower_interest_rate", maxlength: 18 }),
    ...controls.displayText({ tab: "refinances", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "refinances", label: "Group", star: false }),
    ...controls.oc({ tab: "refinances", c: "Group", placeHolder: "Group Code", name: "group_code", isRequired: false, fastpath: "groups" }),
    ...controls.showData({ tab: "refinances", displaytype: "capital", data: "group_display" }),

    ...controls.displayText({ tab: "refinances", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "refinances", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "refinances",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "refinances",
        requiredField: ["min_regular_recovery", "max_npa", "min_ots", "lower_interest_rate", "group_code", "group_display", "group_uid",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "refinances",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "refinances",
        requiredField: ["min_regular_recovery", "max_npa", "min_ots", "lower_interest_rate", "group_code", "group_display", "group_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "refinances",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Min Regular Recovery", field: "min_regular_recovery" },
        { label: "Max Npa", field: "max_npa" },
        { label: "Min Ots", field: "min_ots" },
        { label: "Lower Interest Rate", field: "lower_interest_rate" },
        { label: "Group Code", field: "group_code" },
        { label: "Group Display", field: "group_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "refinances"
    },
    ...controls.displayText({ tab: "pacs_notification", label: "Send Notification Step", star: false }),
    ...controls.oc({ tab: "pacs_notification", c: "NotificationStep", placeHolder: "Send Notification Step", name: "send_notification_code", isRequired: false, fastpath: "notification_steps" }),
    ...controls.showData({ tab: "pacs_notification", displaytype: "capital", data: "send_notification_display" }),
    ...controls.displayText({ tab: "pacs_notification", label: "Notification Channel", star: false }),
    ...controls.oc({ tab: "pacs_notification", c: "NotificationChannel", placeHolder: "Notification Channel Code", name: "notification_channel_code", isRequired: false, fastpath: "notification_channels" }),
    ...controls.showData({ tab: "pacs_notification", displaytype: "capital", data: "notification_channel_display" }),
    ...controls.displayText({ tab: "pacs_notification", label: "Show Notification Step", star: false }),
    ...controls.oc({ tab: "pacs_notification", c: "NotificationStep", placeHolder: "Show Notification Step", name: "show_notification_step_code", isRequired: false, fastpath: "notification_steps" }),
    ...controls.showData({ tab: "pacs_notification", displaytype: "capital", data: "show_notification_step_display" }),

    ...controls.displayText({ tab: "pacs_notification", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "pacs_notification", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "pacs_notification",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "pacs_notification",
        requiredField: ["notification_step_code", "notification_step_display", "notification_step_uid", "notification_channel_code", "notification_channel_display", "notification_channel_uid", "notification_step_code", "notification_step_display", "notification_step_uid",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "pacs_notification",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "pacs_notification",
        requiredField: ["notification_step_code", "notification_step_display", "notification_step_uid", "notification_channel_code", "notification_channel_display", "notification_channel_uid", "notification_step_code", "notification_step_display", "notification_step_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "pacs_notification",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Notification Step Code", field: "notification_step_code" },
        { label: "Notification Step Display", field: "notification_step_display" },
        { label: "Notification Channel Code", field: "notification_channel_code" },
        { label: "Notification Channel Display", field: "notification_channel_display" },
        { label: "Notification Step Code", field: "notification_step_code" },
        { label: "Notification Step Display", field: "notification_step_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "pacs_notification"
    },
    ...controls.magicDateLabel({ tab: "recovery_sequences", label: "Start Date", target: "start_date", star: false }),
    ...controls.magicDate({ tab: "recovery_sequences", name: "start_date", dateType: "ontype", isRequired: false }),
    ...controls.displayText({ tab: "recovery_sequences", label: "", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "recovery_sequences", label: "End Date", target: "end_date", star: false }),
    ...controls.magicDate({ tab: "recovery_sequences", name: "end_date", dateType: "ontype", isRequired: false }),
    ...controls.displayText({ tab: "recovery_sequences", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "recovery_sequences", label: "Seq No", star: false }),
    ...controls.numberOnly({ tab: "recovery_sequences", placeHolder: "", name: "seq_no", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "recovery_sequences", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "recovery_sequences", label: "Recovery Type", star: false }),
    ...controls.oc({ tab: "recovery_sequences", c: "RecoveryType", placeHolder: "Recovery Type", name: "recovery_type_code", isRequired: false, fastpath: "recovery_types" }),
    ...controls.showData({ tab: "recovery_sequences", displaytype: "capital", data: "recovery_type_display" }),

    ...controls.displayText({ tab: "recovery_sequences", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "recovery_sequences", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "recovery_sequences",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "recovery_sequences",
        requiredField: ["start_date", "end_date", "seq_no", "recovery_type_code", "recovery_type_display", "recovery_type_uid",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "recovery_sequences",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "recovery_sequences",
        requiredField: ["start_date", "end_date", "seq_no", "recovery_type_code", "recovery_type_display", "recovery_type_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "recovery_sequences",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Start Date", field: "start_date", displaytype: "date" },
        { label: "End Date", field: "end_date", displaytype: "date" },
        { label: "Seq No", field: "seq_no" },
        { label: "Recovery Type Code", field: "recovery_type_code" },
        { label: "Recovery Type Display", field: "recovery_type_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "recovery_sequences"
    },
    ...controls.magicDateLabel({ tab: "rate_of_interests", label: "Start Date", target: "start_date", star: false }),
    ...controls.magicDate({ tab: "rate_of_interests", name: "start_date", dateType: "ontype", isRequired: false }),
    ...controls.displayText({ tab: "rate_of_interests", label: "", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "rate_of_interests", label: "End Date", target: "end_date", star: false }),
    ...controls.magicDate({ tab: "rate_of_interests", name: "end_date", dateType: "ontype", isRequired: false }),
    ...controls.displayText({ tab: "rate_of_interests", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "rate_of_interests", label: "From Amount" }),
    ...controls.floatOnly({ tab: "rate_of_interests", placeHolder: "", name: "from_amount", maxlength: 18 }),
    ...controls.displayText({ tab: "rate_of_interests", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "rate_of_interests", label: "To Amount" }),
    ...controls.floatOnly({ tab: "rate_of_interests", placeHolder: "", name: "to_amount", maxlength: 18 }),
    ...controls.displayText({ tab: "rate_of_interests", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "rate_of_interests", label: "From Months", star: false }),
    ...controls.numberOnly({ tab: "rate_of_interests", placeHolder: "", name: "from_months", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "rate_of_interests", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "rate_of_interests", label: "To Months", star: false }),
    ...controls.numberOnly({ tab: "rate_of_interests", placeHolder: "", name: "to_months", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "rate_of_interests", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "rate_of_interests", label: "Rate Of Interest" }),
    ...controls.floatOnly({ tab: "rate_of_interests", placeHolder: "", name: "rate_of_interest", maxlength: 4 }),
    ...controls.displayText({ tab: "rate_of_interests", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "rate_of_interests", label: "Penal", star: false }),
    ...controls.numberOnly({ tab: "rate_of_interests", placeHolder: "", name: "penal", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "rate_of_interests", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "rate_of_interests", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "rate_of_interests", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "rate_of_interests",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "rate_of_interests",
        requiredField: ["start_date", "end_date", "from_amount", "to_amount", "from_months", "to_months", "rate_of_interest", "penal",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "rate_of_interests",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "rate_of_interests",
        requiredField: ["start_date", "end_date", "from_amount", "to_amount", "from_months", "to_months", "rate_of_interest", "penal",]
      }, width: "col-sm-2"
    }),
    {
      tab: "rate_of_interests",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Start Date", field: "start_date", displaytype: "date" },
        { label: "End Date", field: "end_date", displaytype: "date" },
        { label: "From Amount", field: "from_amount" },
        { label: "To Amount", field: "to_amount" },
        { label: "From Months", field: "from_months" },
        { label: "To Months", field: "to_months" },
        { label: "Rate Of Interest", field: "rate_of_interest" },
        { label: "Penal", field: "penal" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "rate_of_interests"
    },
    ...controls.displayText({ tab: "interest_subvisions", label: "Subvention Authority", star: false }),
    ...controls.oc({ tab: "interest_subvisions", c: "SubventionAuthority", placeHolder: "Subvention Authority", name: "subvention_authority_code", isRequired: false, fastpath: "subvention_authorities" }),
    ...controls.showData({ tab: "interest_subvisions", displaytype: "capital", data: "subvention_authority_display" }),
    ...controls.displayText({ tab: "interest_subvisions", label: "Subvention Criteria", star: false }),
    ...controls.oc({ tab: "interest_subvisions", c: "SubventionCriteria", placeHolder: "Subvention Criteria", name: "subvention_criteria_code", isRequired: false, fastpath: "subvention_criterias" }),
    ...controls.showData({ tab: "interest_subvisions", displaytype: "capital", data: "subvention_criteria_display" }),
    ...controls.displayText({ tab: "interest_subvisions", label: "Loan Type", star: false }),
    ...controls.oc({ tab: "interest_subvisions", c: "LoanType", placeHolder: "Loan Type", name: "loan_type_code", isRequired: false, fastpath: "loan_types" }),
    ...controls.showData({ tab: "interest_subvisions", displaytype: "capital", data: "loan_type_display" }),
    ...controls.displayText({ tab: "interest_subvisions", label: "Posting Type", star: false }),
    ...controls.oc({ tab: "interest_subvisions", c: "PostingType", placeHolder: "Posting Type", name: "posting_type_code", isRequired: false, fastpath: "posting_types" }),
    ...controls.showData({ tab: "interest_subvisions", displaytype: "capital", data: "posting_type_display" }),
    ...controls.displayText({ tab: "interest_subvisions", label: "Max Period", star: false }),
    ...controls.numberOnly({ tab: "interest_subvisions", placeHolder: "", name: "max_period", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "interest_subvisions", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "interest_subvisions", label: "Name", star: false }),
    ...controls.text({ tab: "interest_subvisions", placeHolder: "", name: "name", isRequired: false, width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "interest_subvisions", label: "From Amount" }),
    ...controls.floatOnly({ tab: "interest_subvisions", placeHolder: "", name: "from_amount", maxlength: 10 }),
    ...controls.displayText({ tab: "interest_subvisions", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "interest_subvisions", label: "To Amount" }),
    ...controls.floatOnly({ tab: "interest_subvisions", placeHolder: "", name: "to_amount", maxlength: 10 }),
    ...controls.displayText({ tab: "interest_subvisions", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "interest_subvisions", label: "Subvention Rate" }),
    ...controls.floatOnly({ tab: "interest_subvisions", placeHolder: "", name: "subvention_rate", maxlength: 4 }),
    ...controls.displayText({ tab: "interest_subvisions", label: "", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "interest_subvisions", label: "Is Subsidy", default: false, name: "is_subsidy" }),
    ...controls.checkBox({ tab: "interest_subvisions", label: "Apply At Repayment Only", default: false, name: "apply_at_repayment_only" }),

    ...controls.displayText({ tab: "interest_subvisions", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "interest_subvisions", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "interest_subvisions",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "interest_subvisions",
        requiredField: ["subvention_authority_code", "subvention_authority_display", "subvention_authority_uid", "subvention_criteria_code", "subvention_criteria_display", "subvention_criteria_uid", "loan_type_code", "loan_type_display", "loan_type_uid", "posting_type_code", "posting_type_display", "posting_type_uid", "max_period", "name", "from_amount", "to_amount", "subvention_rate", "is_subsidy", "apply_at_repayment_only",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "interest_subvisions",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "interest_subvisions",
        requiredField: ["subvention_authority_code", "subvention_authority_display", "subvention_authority_uid", "subvention_criteria_code", "subvention_criteria_display", "subvention_criteria_uid", "loan_type_code", "loan_type_display", "loan_type_uid", "posting_type_code", "posting_type_display", "posting_type_uid", "max_period", "name", "from_amount", "to_amount", "subvention_rate", "is_subsidy", "apply_at_repayment_only",]
      }, width: "col-sm-2"
    }),
    {
      tab: "interest_subvisions",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Subvention Authority Code", field: "subvention_authority_code" },
        { label: "Subvention Authority Display", field: "subvention_authority_display" },
        { label: "Subvention Criteria Code", field: "subvention_criteria_code" },
        { label: "Subvention Criteria Display", field: "subvention_criteria_display" },
        { label: "Loan Type Code", field: "loan_type_code" },
        { label: "Loan Type Display", field: "loan_type_display" },
        { label: "Posting Type Code", field: "posting_type_code" },
        { label: "Posting Type Display", field: "posting_type_display" },
        { label: "Max Period", field: "max_period" },
        { label: "Name", field: "name" },
        { label: "From Amount", field: "from_amount" },
        { label: "To Amount", field: "to_amount" },
        { label: "Subvention Rate", field: "subvention_rate" },
        { label: "Is Subsidy", field: "is_subsidy", displaytype: "tick" },
        { label: "Apply At Repayment Only", field: "apply_at_repayment_only", displaytype: "tick" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "interest_subvisions"
    },
    ...controls.checkBox({ tab: "recoveries", label: "From Branch Only", default: false, name: "from_branch_only" }),

    ...controls.displayText({ tab: "recoveries", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "recoveries", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "recoveries",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "recoveries",
        requiredField: ["from_branch_only",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "recoveries",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "recoveries",
        requiredField: ["from_branch_only",]
      }, width: "col-sm-2"
    }),
    {
      tab: "recoveries",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "From Branch Only", field: "from_branch_only", displaytype: "tick" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "recoveries"
    },
    ...controls.checkBox({ tab: "bank_disbursements", label: "Rights To Branch", default: false, name: "rights_to_branch" }),

    ...controls.displayText({ tab: "bank_disbursements", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "bank_disbursements", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "bank_disbursements",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "bank_disbursements",
        requiredField: ["rights_to_branch",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "bank_disbursements",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "bank_disbursements",
        requiredField: ["rights_to_branch",]
      }, width: "col-sm-2"
    }),
    {
      tab: "bank_disbursements",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Rights To Branch", field: "rights_to_branch", displaytype: "tick" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "bank_disbursements"
    },
    ...controls.displayText({ tab: "login_security_types", label: "Role", star: false }),
    ...controls.oc({ tab: "login_security_types", c: "Role", placeHolder: "Role Code", name: "role_code", isRequired: false, fastpath: "roles" }),
    ...controls.showData({ tab: "login_security_types", displaytype: "capital", data: "role_display" }),
    ...controls.displayText({ tab: "login_security_types", label: "Logout Cooling Period In Min", star: false }),
    ...controls.numberOnly({ tab: "login_security_types", placeHolder: "", name: "logout_cooling_period_in_min", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "login_security_types", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "login_security_types", label: "Session Duration In Min", star: false }),
    ...controls.numberOnly({ tab: "login_security_types", placeHolder: "", name: "session_duration_in_min", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "login_security_types", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "login_security_types", label: "Password Policy", star: false }),
    ...controls.oc({ tab: "login_security_types", c: "PasswordPolicy", placeHolder: "Password Policy", name: "password_policy_code", isRequired: false, fastpath: "password_policies" }),
    ...controls.showData({ tab: "login_security_types", displaytype: "capital", data: "password_policy_display" }),
    ...controls.displayText({ tab: "login_security_types", label: "Society", star: false }),
    ...controls.oc({ tab: "login_security_types", length: 4, c: "Society", placeHolder: "Society Code", name: "society_code", isRequired: false, fastpath: "societies" }),
    ...controls.showData({ tab: "login_security_types", displaytype: "capital", data: "society_display" }),
    ...controls.checkBox({ tab: "login_security_types", label: "Simple", default: false, name: "simple" }),
    ...controls.checkBox({ tab: "login_security_types", label: "Qr Code", default: false, name: "qr_code" }),
    ...controls.checkBox({ tab: "login_security_types", label: "Auth Required", default: false, name: "auth_required" }),
    ...controls.checkBox({ tab: "login_security_types", label: "Vpn Only", default: false, name: "vpn_only" }),
    ...controls.checkBox({ tab: "login_security_types", label: "Is Camera Required", default: false, name: "is_camera_required" }),

    ...controls.displayText({ tab: "login_security_types", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "login_security_types", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "login_security_types",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "login_security_types",
        requiredField: ["role_code", "role_display", "role_uid", "logout_cooling_period_in_min", "session_duration_in_min", "password_policy_code", "password_policy_display", "password_policy_uid", "society_code", "society_display", "society_uid", "simple", "qr_code", "auth_required", "vpn_only", "is_camera_required",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "login_security_types",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "login_security_types",
        requiredField: ["role_code", "role_display", "role_uid", "logout_cooling_period_in_min", "session_duration_in_min", "password_policy_code", "password_policy_display", "password_policy_uid", "society_code", "society_display", "society_uid", "simple", "qr_code", "auth_required", "vpn_only", "is_camera_required",]
      }, width: "col-sm-2"
    }),
    {
      tab: "login_security_types",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Role Code", field: "role_code" },
        { label: "Role Display", field: "role_display" },
        { label: "Logout Cooling Period In Min", field: "logout_cooling_period_in_min" },
        { label: "Session Duration In Min", field: "session_duration_in_min" },
        { label: "Password Policy Code", field: "password_policy_code" },
        { label: "Password Policy Display", field: "password_policy_display" },
        { label: "Society Code", field: "society_code" },
        { label: "Society Display", field: "society_display" },
        { label: "Simple", field: "simple", displaytype: "tick" },
        { label: "Qr Code", field: "qr_code", displaytype: "tick" },
        { label: "Auth Required", field: "auth_required", displaytype: "tick" },
        { label: "Vpn Only", field: "vpn_only", displaytype: "tick" },
        { label: "Is Camera Required", field: "is_camera_required", displaytype: "tick" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "login_security_types"
    },
    ...controls.displayText({ tab: "renewals", label: "From Amount" }),
    ...controls.floatOnly({ tab: "renewals", placeHolder: "", name: "from_amount", maxlength: 18 }),
    ...controls.displayText({ tab: "renewals", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "renewals", label: "To Amount" }),
    ...controls.floatOnly({ tab: "renewals", placeHolder: "", name: "to_amount", maxlength: 18 }),
    ...controls.displayText({ tab: "renewals", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "renewals", label: "Farmer Type", star: false }),
    ...controls.oc({ tab: "renewals", c: "FarmerType", placeHolder: "Farmer Type Code", name: "farmer_type_code", isRequired: false, fastpath: "farmer_types" }),
    ...controls.showData({ tab: "renewals", displaytype: "capital", data: "farmer_type_display" }),
    ...controls.displayText({ tab: "renewals", label: "Renewal Criteria", star: false }),
    ...controls.oc({ tab: "renewals", c: "RenewalCriteria", placeHolder: "Renewal Criteria", name: "renewal_criteria_code", isRequired: false, fastpath: "renewal_criterias" }),
    ...controls.showData({ tab: "renewals", displaytype: "capital", data: "renewal_criteria_display" }),

    ...controls.displayText({ tab: "renewals", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "renewals", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "renewals",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "renewals",
        requiredField: ["from_amount", "to_amount", "farmer_type_code", "farmer_type_display", "farmer_type_uid", "renewal_criteria_code", "renewal_criteria_display", "renewal_criteria_uid",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "renewals",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "renewals",
        requiredField: ["from_amount", "to_amount", "farmer_type_code", "farmer_type_display", "farmer_type_uid", "renewal_criteria_code", "renewal_criteria_display", "renewal_criteria_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "renewals",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "From Amount", field: "from_amount" },
        { label: "To Amount", field: "to_amount" },
        { label: "Farmer Type Code", field: "farmer_type_code" },
        { label: "Farmer Type Display", field: "farmer_type_display" },
        { label: "Renewal Criteria Code", field: "renewal_criteria_code" },
        { label: "Renewal Criteria Display", field: "renewal_criteria_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "renewals"
    },
    ...controls.checkBox({ tab: "bank_pacs_settings", label: "Allow Term", default: false, name: "allow_term" }),
    ...controls.checkBox({ tab: "bank_pacs_settings", label: "Auto Ncl Period", default: false, name: "auto_ncl_period" }),
    ...controls.displayText({ tab: "bank_pacs_settings", label: "Gl", star: false }),
    ...controls.oc({ tab: "bank_pacs_settings", c: "GL", placeHolder: "Gl Code", name: "gl_code", isRequired: false, fastpath: "gls" }),
    ...controls.showData({ tab: "bank_pacs_settings", displaytype: "capital", data: "gl_display" }),

    ...controls.displayText({ tab: "bank_pacs_settings", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "bank_pacs_settings", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "bank_pacs_settings",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "bank_pacs_settings",
        requiredField: ["allow_term", "auto_ncl_period", "gl_code", "gl_display", "gl_uid",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "bank_pacs_settings",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "bank_pacs_settings",
        requiredField: ["allow_term", "auto_ncl_period", "gl_code", "gl_display", "gl_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "bank_pacs_settings",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Allow Term", field: "allow_term", displaytype: "tick" },
        { label: "Auto Ncl Period", field: "auto_ncl_period", displaytype: "tick" },
        { label: "Gl Code", field: "gl_code" },
        { label: "Gl Display", field: "gl_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "bank_pacs_settings"
    },
  ]
  , history: {
    perPage: 10,
    reportHeader: "Bank Pacs Parameters",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Bank Pacs Parameter Code", accessor: "bank_pacs_parameter_code", },
      { Header: "Bank Pacs Parameter", accessor: "bank_pacs_parameter_display", },
      { Header: "Season", accessor: "BankPACSParameter-season-season_display", },
      { Header: "Hangam", accessor: "BankPACSParameter-hangam-hangam_display", },
    ]
  }
};
export default bank_pacs_parameters;